import { InfoOutlined, QuestionAnswer } from '@mui/icons-material';
import { Box, Button, ButtonProps, Divider } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAppearance } from '~/data/appearance';
import {
  CompanyInformationDialog,
  useCompanyInformationDialog,
} from '~/features/CompanyInformationDialog';
import {
  SendMessageToHRDialog,
  useSendMessageToHRDialog,
} from '~/features/SendMessageToHRDialog';
import { legacyColors } from '~/legacyTheme';

import { useSxStyles } from './useStyles';

type PropsType = {
  iframeMode?: boolean;
};

export const LeftSideMenuActions = (props: PropsType) => {
  const { iframeMode } = props;

  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const { customAppearance } = useAppearance();

  const companyInformationDialog = useCompanyInformationDialog();
  const messageToHRDialog = useSendMessageToHRDialog();

  const leftSideMenuColorSet =
    customAppearance.fTopBarColors &&
    customAppearance.fTopBarColors.fBackgroundColor !== '';

  const actionButtonStyle = {
    ...sxStyles.buttonText,
    color: leftSideMenuColorSet
      ? customAppearance.fLeftSideMenuColors.fIconsColor
      : legacyColors.black,
    ...(leftSideMenuColorSet && {
      '&:hover': {
        backgroundColor: `${customAppearance.fLeftSideMenuColors.fIconsColor}40`,
      },
    }),
  };

  const ActionButton = (button: ButtonProps) => {
    return (
      <>
        <Divider />
        <Button
          {...button}
          sx={actionButtonStyle}
          size="small"
          data-cy={button.key}
          fullWidth={true}
        ></Button>
      </>
    );
  };

  if (iframeMode) {
    return <></>;
  }

  return (
    <Box>
      {companyInformationDialog.isAvailable && (
        <ActionButton
          startIcon={<InfoOutlined />}
          onClick={companyInformationDialog.onOpen}
          disabled={companyInformationDialog.isDisabled}
          data-cy={'company-information'}
        >
          {t('laCompInfo')}
        </ActionButton>
      )}
      {messageToHRDialog.isAvailable && (
        <ActionButton
          startIcon={<QuestionAnswer />}
          onClick={messageToHRDialog.onOpen}
          disabled={messageToHRDialog.isDisabled}
          data-cy={'message-to-hr'}
        >
          {t('messageToHR')}
        </ActionButton>
      )}
      <SendMessageToHRDialog {...messageToHRDialog.dialogProps} />
      <CompanyInformationDialog {...companyInformationDialog.dialogProps} />
    </Box>
  );
};
